import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
  itemWrap: FelaCSS;
  leftBlock: FelaCSS;
  rightBlock: FelaCSS;
}

const styles = (): IStyles => ({
  wrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingTop: '16px',
    paddingBottom: '16px',

    maxWidthTabletSm: {
      paddingTop: '0',
      alignItems: 'stretch',
      flexWrap: 'wrap',
    },
  },

  leftBlock: {
    flexShrink: 0,
    marginRight: '16px',

    maxWidthTabletSm: {
      marginRight: '8px',
      width: `calc(${100 / 3}% - 4px)`,
    },

    superSmallMobile: {
      marginRight: '0',
      marginBottom: '8px',
      width: '100%',
      height: '60px',
    },
  },

  rightBlock: {
    flexShrink: 0,
    flexDirection: 'row',
    alignItems: 'center',

    maxWidthTabletSm: {
      flexGrow: 1,
      flexWrap: 'wrap',
      width: `calc(${(100 / 3) * 2}% - 4px)`,
    },
  },

  itemWrap: {
    flexShrink: 0,

    maxWidthTabletSm: {
      width: 'calc(50% - 4px)',
      height: '70px',
    },

    ':not(:last-of-type)': {
      marginRight: '16px',

      maxWidthTabletSm: {
        marginRight: '0',
      },
    },

    ':nth-of-type(even)': {
      maxWidthTabletSm: {
        marginLeft: '8px',
      },
    },

    ':nth-of-type(n + 3)': {
      maxWidthTabletSm: {
        marginTop: '8px',
      },
    },
  },
});

export default styles;
